function initProductCardElements() {
  const productCards = document.querySelectorAll('.product-card:not(.product-card--initialized)');
  productCards.forEach((productCard) => {

    productCard.classList.add('product-card--initialized');
    const addToCartButton = productCard.querySelector('.product-card__add-to-cart-button');
    addToCartButton.addEventListener('click', async function(event) {
      event.preventDefault();
      if (addToCartButton.classList.contains('product-card__add-to-cart-button--loading')) {
        return;
      }
      addToCartButton.classList.add('product-card__add-to-cart-button--loading');
      await Layout.addToCart(1, addToCartButton.dataset.productId);
      addToCartButton.classList.remove('product-card__add-to-cart-button--loading');
    });

    if (productCard.closest('#shopify-section-cart-sidebar') !== null) {
      productCard.addEventListener('click', async function(event) {
        event.preventDefault();
        if (productCard.classList.contains('product-card--loading')) {
          return;
        }
        productCard.classList.add('product-card--loading');

        const cartPageCheckoutValue = document.getElementById('cart-page-checkout-value');
        const cartPageCheckoutButton = document.getElementById('cart-page-checkout-button');
        cartPageCheckoutButton.classList.add('button--loading');
        cartPageCheckoutValue.classList.add('text--loading');

        await Layout.addToCart(1, addToCartButton.dataset.productId);
        productCard.classList.remove('product-card--loading');
      });
    }

  });
}


if (document.readyState !== 'loading') {
  initProductCardElements();
} else {
  window.addEventListener('DOMContentLoaded', initProductCardElements);
}
